import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, UntypedFormControl } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo, faGripLinesVertical, faTrash } from '@fortawesome/free-solid-svg-icons';
import { RichToolTipDirective } from 'src/app/directives/rich-tool-tip.directive';
import { CriteriaSearchZone } from 'src/app/models/enums/criteria-search-zone';
import { ListItem } from '../filters/models/list-item';

@Component({
    selector: 'app-swap-chip-lists',
    templateUrl: './swap-chip-lists.component.html',
    styleUrls: ['./swap-chip-lists.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SwapChipListsComponent,
            multi: true,
        },
    ],
    imports: [FaIconComponent, MatTooltipModule, CdkDropList, NgClass, CdkDrag, CdkDragHandle, MatChipsModule, RichToolTipDirective],
})
export class SwapChipListsComponent implements OnInit, ControlValueAccessor {
    public criteriaSearchZonesTooltipContent =
        "Ce paramètre permet de définir les zones du mail reçu dans lesquelles l'expression booléenne ou l’expression régulière spécifiée dans le champ <b>mode de recherche</b> sera évaluée.<br> Il est possible de définir plusieurs zones, l’évaluation sera alors effectuée sur chaque zone dans l’ordre indiqué jusqu’à ce que l’expression soit vérifiée.<br>Les zones proposées sont :<ul><li><b>Sujet</b> : L’expression est évaluée sur le sujet du mail</li><li><b>Corps</b>  : L’expression est évaluée sur le contenu du mail</li><li><b>Pièce-jointe</b>  : L’expression est évaluée sur le contenu des pièces-jointes (voir les types de pièces-jointes compatibles) </li></ul>";

    public faGripLinesVertical = faGripLinesVertical;
    public faDelete = faTrash;
    public faCircleInfo = faCircleInfo;

    unusedItems: ListItem<CriteriaSearchZone>[] = [
        new ListItem(CriteriaSearchZone.Subject, this.getLabel(CriteriaSearchZone.Subject)),
        new ListItem(CriteriaSearchZone.Body, this.getLabel(CriteriaSearchZone.Body)),
        new ListItem(CriteriaSearchZone.Attachment, this.getLabel(CriteriaSearchZone.Attachment)),
    ];

    selectedItems: ListItem<CriteriaSearchZone>[] = [];

    _control: NgControl;

    disabled: boolean = false;

    onChange: (value?: CriteriaSearchZone[]) => void;
    onTouch: () => void;

    constructor(private injector: Injector) {}

    ngOnInit() {
        this._control = this.injector.get(NgControl);
        //console.log("registrationForm",this._control)
        //this.control = this.abstractcontrol as NgControl;
    }

    get control() {
        return this._control.control as UntypedFormControl;
    }

    // this method sets the value programmatically
    writeValue(value: CriteriaSearchZone[]) {
        if (value != null) {
            console.log('value', value);
            let all = this.unusedItems.map((x) => x.value);
            console.log('all', all);
            let remaining = all.filter((item) => value.indexOf(item) < 0);
            console.log('remaining', remaining);
            this.unusedItems = remaining.map((x) => new ListItem(x, this.getLabel(x)));
            this.selectedItems = value.map((x) => new ListItem(x, this.getLabel(x)));
        }
    }

    // upon UI element value changes, this method gets triggered
    registerOnChange(fn: any) {
        this.onChange = fn;
    }
    // upon touching the element, this method gets triggered
    registerOnTouched(fn: any) {
        this.onTouch = fn;
    }

    drop(event: CdkDragDrop<CriteriaSearchZone[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

            if (this.onChange) {
                this.onChange(this.selectedItems.map((x) => x.value));
            }
        } else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);

            if (this.onChange) {
                this.onChange(this.selectedItems.map((x) => x.value));
            }
        }
    }

    getLabel(criteriaSearchZone: CriteriaSearchZone) {
        switch (criteriaSearchZone) {
            case CriteriaSearchZone.Subject:
                return 'Sujet';
            case CriteriaSearchZone.Body:
                return 'Corps';
            case CriteriaSearchZone.Attachment:
                return 'Pièce-jointe';
        }
    }

    /**
     * Appellé lorsque l'utilisateur clique sur l'icone supprimer d'une zone de recherche.
     * @param stateName Element à supprimer.
     */
    public onRemoveSearchZone(criteriaSearchZone: ListItem<CriteriaSearchZone>) {
        console.log('onRemoveSearchZone', criteriaSearchZone);
        this.selectedItems.splice(
            this.selectedItems.findIndex((x) => x.value == criteriaSearchZone.value),
            1
        );
        this.unusedItems.push(criteriaSearchZone);

        if (this.onChange) {
            this.onChange(this.selectedItems.map((x) => x.value));
        }
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
